module.exports = __webpack_public_path__ + "static/media/logo-apple.af13f81a.svg";